// footer component with tailwind css 

import React from 'react';
import './App.css';
import logo from './binary-white.svg';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        // render text with white foreground and black background
        // using tailwind css
        //
        // <div className="flex justify-left h-16 bg-gray-800 text-white">        
        // <div className="relative min-h-screen">
        <div>
            <div className="fixed bottom-0 bg-gray-500 text-white w-full z-50">
                <div className="grid grid-cols-3">
                    <div className="justify-self-start col-span-2 flex mt-6 mx-2 sm:text-xs">
                    &copy; Binary Inventions {new Date().getFullYear()}
                    </div>

                    <div className="justify-self-end">
                        <Link to="/">
                            <img src={logo} className="w-32 m-2 sm:px-1.5 fill-current" alt="logo" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>            
    );
}

export default Footer;
